import React from 'react';
import { createPortal } from 'react-dom';

export default function AlertOverlay({ message }) {
  if (typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div id="custom-alert-overlay" className="visible">
      <div className="alert-box">
        <div className="spinner"></div>
        <span className="alert-text">{message}</span>
      </div>
    </div>,
    document.body
  );
}
